export type GiftcardDesignId =
  | 'DEFAULT'
  | 'WATERCOLOR'
  | 'GRADIENT'
  | 'BIRTHDAY'

// The two card-surface tones used on the ticket preview, mirroring the real
// generated PDF: every design uses the blue surface except GRADIENT, which
// uses the warm beige.
export const GIFTCARD_PREVIEW_SURFACE_BLUE = '#ECF9FD'
export const GIFTCARD_PREVIEW_SURFACE_BEIGE = '#FBF8F4'

// Each design is identified by name — the artwork filenames encode the design.
// `buttonBackgroundImage` is the square background shown behind the option in
// the design picker (GiftcardDesignPicker). `backgroundImage` is the tall
// illustrated background used on the ticket preview card; designs without one
// fall back to GIFTCARD_PREVIEW_FALLBACK_BACKGROUND. `previewSurfaceColor` is
// the solid colour of the card surfaces (Von/Für panel, redeem steps).
export const GIFTCARD_DESIGNS: {
  id: GiftcardDesignId
  buttonBackgroundImage: string
  backgroundImage?: string
  previewSurfaceColor?: string
}[] = [
  {
    id: 'DEFAULT',
    buttonBackgroundImage:
      '/_nuxt3-static/giftcard/design-default-preview.webp',
    backgroundImage: '/_nuxt3-static/giftcard/design-default-bg.webp',
    previewSurfaceColor: GIFTCARD_PREVIEW_SURFACE_BLUE,
  },
  {
    id: 'WATERCOLOR',
    buttonBackgroundImage:
      '/_nuxt3-static/giftcard/design-watercolor-preview.webp',
    backgroundImage: '/_nuxt3-static/giftcard/design-watercolor-bg.webp',
    previewSurfaceColor: GIFTCARD_PREVIEW_SURFACE_BLUE,
  },
  {
    id: 'GRADIENT',
    buttonBackgroundImage:
      '/_nuxt3-static/giftcard/design-gradient-preview.webp',
    backgroundImage: '/_nuxt3-static/giftcard/design-gradient-bg.webp',
    previewSurfaceColor: GIFTCARD_PREVIEW_SURFACE_BEIGE,
  },
  {
    id: 'BIRTHDAY',
    buttonBackgroundImage:
      '/_nuxt3-static/giftcard/design-birthday-preview.webp',
    backgroundImage: '/_nuxt3-static/giftcard/design-birthday-bg.webp',
    previewSurfaceColor: GIFTCARD_PREVIEW_SURFACE_BLUE,
  },
]

/** One option in GiftcardDesignPicker (built-in or themed design). */
export interface GiftcardDesignOption<T extends string = string> {
  id: T
  label: string
  image?: string
  color?: string
}

export const GIFTCARD_PREVIEW_FALLBACK_BACKGROUND = '#f3ebe0'
